module.exports = __webpack_public_path__ + "bin/2a24296fd289a5db2afbf69ebe8d82db.png";